export default {
    title: {
        zh: "根据文字描述生成图片的人工智能",
        en: "Generating Images from Text Descriptions"
    },
    name_placeholder: {
        zh: "请输入您的名字或昵称",
        en: "Enter you username"
    },
    name_prompt: {
        zh: "您的昵称",
        en: "Name"
    },
    input_placeholder: {
        zh: "请输入您想要生成的图片描述",
        en: "Enter the text description for your desired image"
    },
    input_prompt: {
        zh: "图片描述",
        en: "Image Description"
    },
    warning_text: {
        zh: "CogView生成模型仅支持简体中文输入。",
        en: "The CogView generation model only supports simplified Chinese input. You can use the translation button in the input box to translate the input text into Chinese."
    },
    regenerate: {
        zh: "重新生成",
        en: "Regenerate"
    },
    generate: {
        zh: "生成",
        en: "Generate"
    },
    show_history: {
        zh: "查看历史",
        en: "Show History"
    },
    queue_list: {
        zh: "排队列表（当前数量：%size）",
        en: "Queue (Current waiting: %size)"
    },
    queue_time: {
        zh: " / 预计排队时间：%size min",
        en: " / Estimate waiting time: %size min"
    },
    author_prompt: {
        zh: "作者：",
        en: "Author: "
    },
    create_time_prompt: {
        zh: "创建时间：",
        en: "Create Time: "
    },
    generate_time_prompt: {
        zh: "生成时间：",
        en: "Generate Time: "
    },
    history_records: {
        zh: "历史记录",
        en: "History Records"
    },
    task_not_found: {
        zh: "未找到生成任务",
        en: "Task Not Found"
    },
    plz_regenerate: {
        zh: "请重新生成",
        en: "Please Regenerate"
    },
    generate_fail: {
        zh: "生成失败",
        en: "Generation Failed"
    },
    plz_regenerate_or_other: {
        zh: "请重新生成，或尝试其他文本进行生成",
        en: "Please regenerate or try other inputs"
    },
    submitted_and_queue: {
        zh: "已提交，正在排队中",
        en: "Submitted. Task waiting in queue now."
    },
    generating: {
        zh: "正在生成中",
        en: "Generating"
    },
    generate_and_wait: {
        zh: "生成一般需要几分钟时间，请耐心等待结果",
        en: "Generation usually takes several minutes. Please wait for a while."
    },
    input_name_not_empty: {
        zh: "输入的昵称不能为空",
        en: "Your name must not be empty."
    },
    input_length_not_valid: {
        zh: "输入的图片描述长度在2～30之间，当前长度：%size",
        en: "The number of characters in input image description must be between 2 and 30. Current length: %size"
    },
    submit_too_fast: {
        zh: "提交时间过快，请稍等片刻。",
        en: "Submission too fast. Please wait for a while."
    },
    service_err: {
        zh: "服务异常：%err",
        en: "Service error: %err"
    },
    translation_succeed: {
        zh: "翻译成功。",
        en: "Translation succeed. "
    },
    translation_failed: {
        zh: "翻译失败。",
        en: "Translation failed. "
    },
    load_history_records: {
        zh: "加载%size条历史记录。",
        en: "Load %size history records."
    },
    generation_succeed_all_img: {
        zh: "生成成功！总共生成%size张图片。",
        en: "Generation succeed. %size images generated in total."
    },
    request_failed: {
        zh: "请求失败：",
        en: "Request failed:"
    },
    switch_lang: {
        zh: "English Display",
        en: "中文界面"
    },
    github: {
        zh: "Github",
        en: "Github"
    }
}